import { navigate } from 'gatsby';

/** 사용하지 않음 >> 세일즈포스 연동
export const BANK_MAP = {
  '039': `경남은행`,
  '034': `광주은행`,
  '261': `교보증권`,
  '003': `기업은행`,
  '012': `농.축협`,
  '031': `대구은행`,
  '267': `대신증권`,
  '055': `도이치은행`,
  '287': `메리츠증권`,
  '238': `미래에셋대우`,
  '290': `부국증권`,
  '032': `부산은행`,
  '061': `비엔피파리바은행`,
  '064': `산림조합중앙회`,
  '002': `산업은행`,
  '240': `삼성증권`,
  '045': `새마을금고`,
  '007': `수협은행`,
  '053': `시티은행`,
  '291': `신영증권`,
  '278': `신한금융투자`,
  '088': `신한은행`,
  '048': `신협`,
  '020': `우리은행`,
  '071': `우체국`,
  '209': `유안타증권`,
  '280': `유진투자증권`,
  '265': `이베스트투자증권`,
  '050': `저축은행`,
  '037': `전북은행`,
  '057': `제이피모간체이스은행`,
  '035': `제주은행`,
  '062': `중국공상은행`,
  '090': `카카오뱅크`,
  '089': `케이뱅크`,
  '292': `케이프투자증권`,
  '264': `키움증권`,
  '270': `하나금융투자`,
  '081': `하나은행`,
  '262': `하이투자증권`,
  '027': `한국씨티은행`,
  '293': `한국증권금융`,
  '243': `한국투자증권`,
  '294': `한국포스증권`,
  '269': `한화투자증권`,
  '263': `현대차증권`,
  '060': `BOA은행`,
  '279': `DB금융투자`,
  '054': `HSBC은행`,
  '004': `KB국민은행`,
  '218': `KB증권`,
  '011': `NH농협은행`,
  '247': `NH투자증권`,
  '289': `NH투자증권`,
  '023': `SC제일은행`,
  '266': `SK증권`,
};
 */
export const PAYTYPE_REGULAR_AUTO_BANKING = `FA04`;
export const PAYTYPE_REGULAR_CARD = `FA05`;
export const PAYTYPE_REGULAR_NAVERPAY = `FANP`;
export const PAYTYPE_ONCE_CARD = `FG11`;
export const PAYTYPE_ONCE_PHONE = `FG07`;
export const PAYTYPE_ONCE_BANKING = `FG12`;
export const PAYTYPE_ONCE_NAVERPAY = `FGNO`;

export const PAYMENT_TYPE_NAMES: { [key: string]: string } = {
  [PAYTYPE_REGULAR_AUTO_BANKING]: `자동이체`,
  [PAYTYPE_REGULAR_CARD]: `신용카드`,
  [PAYTYPE_REGULAR_NAVERPAY]: `네이버페이`,
  [PAYTYPE_ONCE_CARD]: `신용카드`,
  [PAYTYPE_ONCE_PHONE]: `휴대폰결제`,
  [PAYTYPE_ONCE_BANKING]: `무통장`,
  [PAYTYPE_ONCE_NAVERPAY]: `네이버페이`,
};

// 이니시스 결제수단 값 매핑
export const INICIS_PAY_METHOD_PC_MAP: {
  [key: string]: 'Card' | 'HPP' | 'VBank';
} = {
  [PAYTYPE_ONCE_CARD]: `Card`,
  [PAYTYPE_ONCE_PHONE]: `HPP`,
  [PAYTYPE_ONCE_BANKING]: `VBank`,
};

// 이니시스 결제수단 값 매핑
export const INICIS_PAY_METHOD_MOBILE_MAP: {
  [key: string]: 'CARD' | 'VBANK' | 'MOBILE';
} = {
  [PAYTYPE_ONCE_CARD]: `CARD`,
  [PAYTYPE_ONCE_PHONE]: `MOBILE`,
  [PAYTYPE_ONCE_BANKING]: `VBANK`,
};

// 표준 금융기관코드 → KCP 은행코드 매핑 (가상계좌용)
export const KCP_BANK_MAP: { [key: string]: string } = {
  '003': 'BK03', // IBK기업은행
  '004': 'BK04', // KB국민은행
  '007': 'BK07', // 수협은행
  '011': 'BK11', // NH농협은행
  '020': 'BK20', // 우리은행
  '023': 'BK23', // SC제일은행
  '088': 'BK26', // 신한은행
  '031': 'BK31', // 대구은행(iM뱅크)
  '032': 'BK32', // 부산은행
  '034': 'BK34', // 광주은행
  // '035': 'BK35', // 제주은행 — KCP HUB API 가상계좌 미지원 (에러 8306)
  // '037': 'BK37', // 전북은행 — KCP HUB API 가상계좌 미지원 (에러 8306)
  '039': 'BK39', // 경남은행
  '071': 'BK71', // 우체국
  '081': 'BK81', // 하나은행
};

// 입금기한 계산 (오늘 + daysFromNow일, yyyyMMddHHmmss 포맷)
export const getKcpVaDate = (daysFromNow = 3): string => {
  const d = new Date();
  d.setDate(d.getDate() + daysFromNow);
  d.setHours(23, 59, 59, 0);
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}` +
    `${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`
  );
};

// 가상계좌 입금기한 포맷 (20260220235959 → 2026년 02월 20일 23시 59분)
export const formatVaDate = (vaDate?: string): string => {
  if (!vaDate || vaDate.length < 12) return '';
  const y = vaDate.substring(0, 4);
  const m = vaDate.substring(4, 6);
  const d = vaDate.substring(6, 8);
  const h = vaDate.substring(8, 10);
  const mi = vaDate.substring(10, 12);
  return `${y}년 ${m}월 ${d}일 ${h}시 ${mi}분`;
};

// KCP 결제수단 값 매핑
export interface KCP_PAY_METHOD_TYPE {
  pc: '100000000000' | '000010000000' | '001000000000' | 'AUTH:CARD';
  mobile: 'CARD' | 'MOBX' | 'VCNT' | 'AUTH';
}
export const KCP_PAY_METHOD_PC_MAP: {
  [key: string]: KCP_PAY_METHOD_TYPE['pc'];
} = {
  [PAYTYPE_ONCE_CARD]: `100000000000`,
  [PAYTYPE_ONCE_PHONE]: `000010000000`,
  [PAYTYPE_ONCE_BANKING]: `001000000000`,
};

// KCP 결제수단 값 매핑
export const KCP_PAY_METHOD_MOBILE_MAP: {
  [key: string]: KCP_PAY_METHOD_TYPE['mobile'];
} = {
  [PAYTYPE_ONCE_CARD]: `CARD`,
  [PAYTYPE_ONCE_PHONE]: `MOBX`,
  [PAYTYPE_ONCE_BANKING]: `VCNT`,
};

// 정기후원 계좌 상태값
export const REGCD_NEW = `FT00`; // 신규
export const REGCD_CANCEL = `FT01`; // 해지
export const REGCD_MODIFY = `FT02`; // 변경
export const REGCD_FAIL = `FT03`; // 실패
export const REGCD_COMPLETE = `FT11`; // 등록완료

// 세일즈포스 결제수단 타입
export const SALESFORCE_PAYMENT_METHOD_TYPE_CARD = 'Card';
export const SALESFORCE_PAYMENT_METHOD_TYPE_CMS = 'CMS';
export const SALESFORCE_PAYMENT_METHOD_TYPE_NPAY = 'Naver Pay';

// 결제 방법을 입력 받아 PG사 타입 코드 반환
export const getPgType = (confPgType: string, payType: string) => {
  if ([PAYTYPE_ONCE_NAVERPAY, PAYTYPE_REGULAR_NAVERPAY].includes(payType)) {
    // 네이버페이
    return 'NPAY';
  } else if ([PAYTYPE_REGULAR_AUTO_BANKING].includes(payType)) {
    // 자동이체
    return 'FMS';
  } else return confPgType;
};

// 정기후원 결제 방법 볓 결제일 목록
export const PAYTYPE_PAYMENT_DAY_LIST: {
  [key: string]: any[];
} = {
  [PAYTYPE_REGULAR_AUTO_BANKING]: [
    { day: '05' },
    { day: '15' },
    { day: '25' },
    { day: 'Last_Day', dayKo: '말' },
  ],
  [PAYTYPE_REGULAR_CARD]: [{ day: '10' }, { day: '20' }],
  [PAYTYPE_REGULAR_NAVERPAY]: [{ day: '12' }, { day: '18' }],
};
// 정기후원 결제방법명을 결제방법코드로 변환
export const getPaymentTypeNameToCode = (payType: string): string => {
  switch (payType) {
    case SALESFORCE_PAYMENT_METHOD_TYPE_CMS:
      return PAYTYPE_REGULAR_AUTO_BANKING;
    case SALESFORCE_PAYMENT_METHOD_TYPE_NPAY:
      return PAYTYPE_REGULAR_NAVERPAY;
    case SALESFORCE_PAYMENT_METHOD_TYPE_CARD:
      return PAYTYPE_REGULAR_CARD;
    default:
      return '';
  }
};

// 결제수단 타입에 따른 라벨 반환
export const getPaymentTypeLabel = (paymentType: string) => {
  switch (paymentType) {
    case SALESFORCE_PAYMENT_METHOD_TYPE_CARD:
      return '신용카드';
    case SALESFORCE_PAYMENT_METHOD_TYPE_CMS:
      return '자동이체';
    case SALESFORCE_PAYMENT_METHOD_TYPE_NPAY:
      return '네이버페이(Npay)';
    default:
      return '결제수단';
  }
};

const PaymentHelper = {
  onComplete: (url: string, orderNumber: string | undefined) => {
    let completeUrl = url;
    if (orderNumber) {
      if (completeUrl.indexOf('?') < 0)
        completeUrl = `${completeUrl}?orderNumber=${orderNumber}`;
      else completeUrl = `${completeUrl}&orderNumber=${orderNumber}`;
    }
    if (completeUrl.indexOf('?') > -1 && completeUrl.indexOf('/?') === -1) {
      completeUrl = completeUrl.replace('?', '/?');
    }
    console.log('++ completeUrl : ', completeUrl);
    window.location.href = completeUrl;
    // navigate 정상 작동 하지 않음
    // navigate(completeUrl);
  },
};
export default PaymentHelper;
